const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_AGENTS': {
      const self = action.users.find((agent) => agent.username === state.username);
      if (self) {
        return { ...state, ...self };
      }
      // Current user wasn't part of the agent search result set for some reason.
      return state;
    }
    case 'LOGIN': {
      const patch = action.user.can_view_reports === undefined;
      return {
        ...state,
        ...action.user,
        // Shim to handle mismatching API versions. REMOVE AT SOME POINT.
        can_view_reports: patch || action.user.can_view_reports,
      };
    }
    case 'UPDATE_USER': {
      return {
        ...state,
        ...action.payload,
      };
    }
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
